<template>
  <div class="aboutUs">
    <sectionTitle :titleObj="titleObj"></sectionTitle>
    <div class="content">
      <div class="menu">
        <router-link :to="{ path: item.path }" class="menu-item flex-center" :class="{'menu-item-select':isActive(item.path)}" v-for="item in menu" :key="item.name">{{item.name}}</router-link>
      </div>
      <div style="flex:1">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import sectionTitle from '@/components/sectionTitle.vue'

export default {
  components:{
    sectionTitle
  },
  data(){
    return {
      titleObj:{
        title:'会员服务',
        subtitle:'MEMBERSHIP SERVICE'
      },
      menu:[
        {
          name:'会员风采',
          path:'/memberService/memberShowcase'
        },
        {
          name:'会员招聘',
          path:'/memberService/recruitment'
        },
        {
          name:'会员通知',
          path:'/memberService/memberNotice'
        },
      ]
    }
  },
  created(){
    this.checkQueryParams()
  },
  methods:{
    isActive(path){
      return this.$route.path === path
    },
    checkQueryParams(){
      const tabsName = this.$route.query.tabsName
      if(tabsName){
        const targetMenu = this.menu.find(item => item.name === tabsName)
        if(targetMenu){
          this.$router.replace(targetMenu.path)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.aboutUs{
  padding:0 10%;
  padding-bottom: 109px;
}
.content{
  gap:64px;
  display: flex;
  .menu{
    display: flex;
    flex-direction: column;
    gap:8px;
    .menu-item{
      width: 257px;
      height: 64px;
      background: #f3f1ef;
      cursor: pointer;
      font-size: 20px;
      color:#333333;
    }
    .menu-item-select{
      background: #ed9d26;
      color:#FFFFFF;
    }
  }
  .title{
    font-size: 36px;
    color: #333333;
    font-weight: bold;
    text-align: center;
    margin-bottom: 32px;
  }
  .introduce{
    font-size: 20px;
    color: #333333;
    line-height: 48px;
  }
}


</style>